// extracted by mini-css-extract-plugin
export default {"overlay":"pA-z","bodyOpen":"qA-z","content":"rA-z","header":"sA-z","close":"tA-z","closeNoHeading":"uA-z"};